var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.spans),function(item){return _c('span',{key:item.key,class:item.classes},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }